import { Controller } from "@hotwired/stimulus"
import { type TurboFrameMissingEvent } from "@hotwired/turbo"

export default class TurboFrameMissingController extends Controller<HTMLElement> {
  static values = { frameId: String }
  declare readonly frameIdValue: string

  showNotice(e: TurboFrameMissingEvent): void {
    const turboFrame = e.target as HTMLElement

    if (turboFrame.id === this.frameIdValue) {
      turboFrame.hidden = true
      this.element.hidden = false
    }
  }
}
